<template>
  <div class="mypage-ec-site-connect-button-parts">
    <h3 class="mypage-ec-site-connect-button-parts__title">
      {{ $tc('MypagePage.MypageEcSiteConnectPage.connect.title') }}
    </h3>
    <div class="mypage-ec-site-connect-button-parts__description">
      <p
        v-if="ecConnectStatus === 'connectedGuestOnly'"
        class="mypage-ec-site-connect-button-parts__description-guest"
        v-text="$tc('MypagePage.MypageEcSiteConnectPage.connect.description.guestOnly')"
      ></p>
      <p
        class="mypage-ec-site-connect-button-parts__description-paragraph"
        v-text="$tc('MypagePage.MypageEcSiteConnectPage.connect.description.paragraph')"
      ></p>
      <ul class="mypage-ec-site-connect-button-parts__list">
        <li class="mypage-ec-site-connect-button-parts__item">
          {{ $tc('MypagePage.MypageEcSiteConnectPage.connect.description.item1') }}
        </li>
        <li class="mypage-ec-site-connect-button-parts__item">
          {{ $tc('MypagePage.MypageEcSiteConnectPage.connect.description.item2') }}
        </li>
      </ul>
    </div>
    <atom-button
      class="mypage-ec-site-connect-button-parts__button"
      :class="`mypage-ec-site-connect-button-parts__button--count${state.count}`"
      :linkText="connectButtonLabel"
      :disabled="ecConnectStatus === 'connecting'"
      @onClick="handleConnectEc"
    />
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  PropType,
  reactive,
  watch,
} from '@vue/composition-api'
import AtomButton from '@/components/atoms/AtomButton.vue'
import i18n from '@/locales/I18n'
import type { EcConnectStatusType } from '@/store/stores/pageStore/MypagePage/MypagePageStore'

export default defineComponent({
  name: 'MypageEcSiteConnectButtonParts',
  components: {
    AtomButton,
  },
  props: {
    ecConnectStatus: {
      type: String as PropType<EcConnectStatusType>,
      required: true,
    },
  },
  setup(props) {
    const animationDelay = 500
    const state = reactive({
      animationTimerId: 0,
      count: 0,
    })

    /**
     * 連携するボタンのラベル
     */
    const connectButtonLabel = computed(() =>
      props.ecConnectStatus === 'connecting'
        ? i18n.tc('MypagePage.MypageEcSiteConnectPage.connectingButtonLabel')
        : i18n.tc('MypagePage.MypageEcSiteConnectPage.connectButtonLabel'),
    )
    /**
     * 連携中のアニメーション用クラスを付与
     */
    const connectingAnimate = () => {
      state.animationTimerId = window.setInterval(() => {
        state.count += 1
        if (state.count > 3) {
          state.count = 0
        }
      }, animationDelay)
    }
    watch(
      () => props.ecConnectStatus,
      () => {
        if (props.ecConnectStatus === 'connecting') {
          connectingAnimate()
        } else {
          clearInterval(state.animationTimerId)
          state.count = 0
        }
      },
    )
    onBeforeUnmount(() => {
      clearInterval(state.animationTimerId)
    })

    if (props.ecConnectStatus === 'connecting') {
      connectingAnimate()
    }

    return {
      state,
      connectButtonLabel,
    }
  },
  methods: {
    handleConnectEc() {
      this.$emit('connectEc')
    },
  },
})
</script>

<style scoped lang="scss">
.mypage-ec-site-connect-button-parts {
  &__title {
    font-size: 17px;
    font-weight: 500;
  }

  &__description {
    max-width: 480px;
    margin: 12px auto 0;
    font-size: 13px;
    white-space: pre-wrap;
    text-align: left;
    line-height: 1.54;

    &-guest {
      text-align: center;
      color: $red;
      margin-bottom: 8px;
    }
  }

  &__item {
    position: relative;
    padding-left: 1.5em;

    &::before {
      position: absolute;
      top: 0.6em;
      left: 0.6em;
      width: 4px;
      height: 4px;
      content: '';
      background-color: $gray75;
      border-radius: 50%;
    }
  }

  &__button {
    max-width: 347px;
    margin: 12px auto;

    &:disabled {
      color: $gray75;
    }

    &--count1 {
      &::after {
        content: '.';
      }
    }

    &--count2 {
      &::after {
        content: '..';
      }
    }

    &--count3 {
      &::after {
        content: '...';
      }
    }
  }
}
</style>
